<template>
  <div>
    Empty component
  </div>
</template>

<script setup>

</script>
